import React, { useMemo } from 'react'
import PropTypes from 'prop-types'

import { TileSlider } from 'Components'
import ListingPreview, { extractListingPreviewProps } from 'Components/ListingPreview'
import BuildingPreviewWithFav from 'Components/BuildingPreviewWithFav'
// import Flex from 'Components/Flex'

// import css from './styles.js'
import { _PreviewSliderSection, _Slide } from './styles'

const GA_SOURCE = 'Preview Slider Section'


const PreviewSliderSection = (
  {
    className,
    mobileBrowser,
    userIsAuthentificated,
    listings,
    buildings,
    maxListingCount = 4,
    handleClick = () => {},
    dataSource = '',
    gaCategory,
    sourcePage,
    isMobileApp,
    nearbyListingsOrSimilarListings,
    estimateListing,
  }) => {
  const buildingList = useMemo(() => buildings && buildings.slice(0, maxListingCount), [buildings])
  const listingList = useMemo(() => listings && listings.slice(0, maxListingCount), [listings])
  const getPreviewList = () => {
    if(buildings) {
      return buildingList.map(building => (
        <BuildingPreviewWithFav
          showDistance
          key={building.id}
          building={building}
          userIsAuthentificated={userIsAuthentificated}
          handleClick={handleClick}
          gaCategory={sourcePage}
          gaSource={GA_SOURCE}
        />
      ))
    } if(listings) {
      return listingList.map(listing => {
        const previewProps = extractListingPreviewProps(listing)
        const isLocked = userIsAuthentificated ? false : listing.advertise_permission === 0
        return (
          <ListingPreview
            key={`listing_preview_${listing.id}`}
            {...previewProps}
            gridNumber={12}
            showSlider={false}
            isLocked={isLocked}
            noMarginBox
            handleClick={handleClick}
            dataSource={dataSource}
            gaCategory={gaCategory}
            sourcePage={sourcePage}
            hideImageCount
            estimateListing={estimateListing}
          />
        )
      })
    }
    return []
  }
  const listingSliderElements = getPreviewList()
  return (
    <_PreviewSliderSection
      data-test-id="previewSliderSection"
      mobileBrowser={mobileBrowser}
      className={className}
      isBuilding={buildings}
    >
      {
        isMobileApp ?
          listingSliderElements :
          (
            <TileSlider
              nearbyListingsOrSimilarListings={nearbyListingsOrSimilarListings}
            >
              {
                listingSliderElements.map(sliderElement => (
                  <_Slide key={sliderElement.key} isBuilding={buildings}>
                    {sliderElement}
                  </_Slide>
                ))
              }
            </TileSlider>
          )
      }
    </_PreviewSliderSection>
  )
}

PreviewSliderSection.propTypes = {
  className: PropTypes.string,
  mobileBrowser: PropTypes.bool,
  userIsAuthentificated: PropTypes.bool,
  listings: PropTypes.arrayOf(PropTypes.shape({})),
  buildings: PropTypes.arrayOf(PropTypes.shape({})),
  maxListingCount: PropTypes.number,
  handleClick: PropTypes.func,
  dataSource: PropTypes.string,
  gaCategory: PropTypes.string,
  sourcePage: PropTypes.string,
  isMobileApp: PropTypes.bool,
  nearbyListingsOrSimilarListings: PropTypes.bool,
  estimateListing: PropTypes.shape({}),
}

export default PreviewSliderSection
